import {GovIcon} from "@gov-design-system-ce/react";

export interface IconProps {
    type?: string;
    name?: string;
    size?: "2xl" | "3xl" | "4xl" | "6xl" | "l" | "m" | "s" | "xl" | "xs";
}

function Icon(props: Readonly<IconProps>) {
    return (
        <GovIcon {...props} />
    );
}


export function FileEarmarkText(props: Readonly<IconProps>) {
    return (
        <Icon {...props} name="file-earmark-text" type={"basic"} />
    );
}

export function HouseDoorFill(props: Readonly<IconProps>) {
    return (
        <Icon {...props} name="house-door-fill" type={"basic"} />
    );
}

export function GearFill(props: Readonly<IconProps>) {
    return (
        <Icon {...props} name="gear-fill" type={"basic"} />
    );
}

export function PersonBadge(props: Readonly<IconProps>) {
    return (
        <Icon {...props} name="person-badge" type={"basic"} />
    );
}
